import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface GetMyCardsNowButtonProps {
  showCompleteAccount?: boolean
  onClick: () => void
}

const GetMyCardsNowButton: React.FC<GetMyCardsNowButtonProps> = ({
  showCompleteAccount,
  onClick,
}) => (
  <Button type="primary" onClick={onClick}>
    {showCompleteAccount
      ? i18n.t('software_management.initial_setup.get_started_block.cta_complete')
      : i18n.t('expenses_v2.cards.blocks.require_onboarding.get_my_cards_now')}
  </Button>
)

export default GetMyCardsNowButton
